import React from 'react'
import { Title } from '../../atoms'

export const NameBox = ({ heading, name, className = 'nameBox' }) => {
  return (
    <div className={className}>
      <Title text={heading} className="heading text-nowrap" />
      <Title text={name} className="name text-nowrap text" />
    </div>
  )
}
